<p-dialog
  class="edit-modal"
  header="Crear ticket de soporte"
  [modal]="true"
  [(visible)]="showSupportModal"
  [style]="{ width: '620px' }"
  *ngIf="showSupportModal"
  [closable]="!creatingTicket"
  closeOnEscape="false"
  (visibleChange)="closeModal()"
>
  <span class="p-text-secondary">
    Cuéntanos qué pasó y el equipo lo revisará.
  </span>

  <form class="form-container" [formGroup]="supportTicketForm" novalidate>
    <div class="form-row">
      <div class="filter-column">
        <label for="subject">Asunto</label>
        <input
          pInputText
          formControlName="subject"
          autocomplete="off"
          placeholder="Ej. Problema con una transferencia"
        />
      </div>
    </div>

    <div class="form-row">
      <div class="filter-column">
        <label for="category">Categoría</label>
        <p-dropdown
          formControlName="category"
          [options]="ticketCategoryOptions"
          optionLabel="name"
          placeholder="Selecciona una categoría"
        />
      </div>
    </div>

    <div class="form-row">
      <div class="filter-column">
        <label for="description">Descripción</label>
        <textarea
          pInputTextarea
          formControlName="description"
          autocomplete="off"
          rows="5"
          placeholder="Describe el problema con el mayor detalle posible"
        ></textarea>
      </div>
    </div>
  </form>

  <div class="buttons-container">
    <p-button
      label="Cancelar"
      severity="secondary"
      (click)="closeModal()"
      [disabled]="creatingTicket"
    />
    <p-button
      label="Crear ticket"
      [disabled]="checkSupportDisabled()"
      [loading]="creatingTicket"
      (click)="createSupportTicket()"
    />
  </div>
</p-dialog>
